// src/i18n/locales/fi.json
export const fi = {

  // fi.json
  // ============================================
  // LISTING (Luonti/Tarkistus)
  // ============================================
  listing: {
    successDescription: 'Ilmoituksesi on nyt luotu, voit tarkistaa ja hallita niitä käyttäjäprofiilistasi.',
    addMore: "Lisää kuvia",
    dragToGroup: "Raahaa ja pudota ryhmitelläksesi kuvat",
    organizePhotos: "Järjestä kuvat",
    continue: "Jatka",
    reviewListings: "Tarkista ilmoitukset",
    image: "Kuvat",
    title: "Otsikko",
    category: "Kategoria",
    price: "Hinta",
    actions: "Toiminnot",
    creating: "Luodaan...",
    createListings: "Luo {{count}} ilmoitus{{plural}}",
    skipToManual: "Luo manuaalisesti",
    analyzePhotos: "Täytä automaattisesti",
    uploadPhotos: "Lisää kuvat",
    uploadingImages: "Ladataan kuvia...",
    description: "Kuvaus",
    editListing: "Muokkaa ilmoitusta",
    size: "Koko",
    uploadDescription: "Voit luoda monta ilmoitusta kerralla lataamalla useita kuvia.",
    successTitle: "Ilmoitukset luotu!",
    viewListings: "Näytä ilmoitukset",
    createMore: "Luo lisää",
    // ⭐ NEW: PhotoGroupingZone translations
    groupName: "Ryhmän nimi (vapaaehtoinen)",
    imageName: "Kuvan nimi (vapaaehtoinen)",
    imageCount: "{{count}} kuvaa",
    dragPhotosHere: "Raahaa kuvia tähän",
    // ⭐ NEW: ListingEditModal translations
    images: "Kuvat",
    coverImage: "Kansi",
    imageUploaded: "Ladattu",
    noImage: "Ei kuvaa",
    condition: "Kunto",
    bookInfo: "Kirjan tiedot",
    aiPriceEstimate: "AI-hinta-arvio",
    reasoning: "Perustelu",
    brand: "Merkki",
    detectedInfo: "AI-tunnistetut tiedot",
    color: "Väri",
    material: "Materiaali",
    confidence: "Luotettavuus"
  },
  // Actions
 actions: {
  workshop: "Ilmainen tietoisku {{date}} ✨",
  buy: "Osta",
  sell: "Myy",
  send: "Lähetä",
  deliver: "Toimita",
  journeys: "Löydä edullisia matkoja",
  books: "Löydä luettavaa",
},
event: {
  title: "Myy nopeammin verkossa",
  free: "Ilmainen tietoisku",
  timePrefix: "klo",
  snacks: "Tarjolla pientä purtavaa",
  description:
    "Kuvat, hinnoittelu ja ajoitus – ja miten tekoälyllä teet saman listauksen Vintediin ja Toriin kerralla.",
  addToCalendar: "Tallenna kalenteriin",
  googleCalendar: "Google Kalenteri",
  reminderTitle: "Tilaa muistutus sähköpostiin",
  reminderHint:
    "Jätä sähköpostisi, niin saat muistutuksen ja osallistumisohjeet ennen tapahtumaa.",
  reminderSuccess:
    "Kiitos! Lähetämme muistutuksen ja osallistumisohjeet sähköpostiisi ennen tapahtumaa.",
  reminderError: "Tilaus epäonnistui. Yritä hetken kuluttua uudelleen.",
  reminderCta: "Tilaa muistutus",
  emailLabel: "Sähköposti",
  invalidEmail: "Tarkista sähköpostiosoite",
  consentLabel:
    "Sähköpostiani saa käyttää vain tämän tapahtuman muistutuksen ja osallistumisohjeiden lähettämiseen.",
  consentRequired:
    "Hyväksy sähköpostin tallennus, jotta voimme lähettää muistutuksen",
},
  header: {
    title: "Teknologia Kauppa",
    home: "Etusivu",
    products: "Tuotteet"
  },
  mode: {
    buy: "Osta",
    sell: "Myy",
    rent: "Vuokraa"
  },
  auth: {
    loginRequired: "Kirjaudu sisään jatkaaksesi",
    login: "Kirjaudu",
    createAccount: "Luo tili",
    email: "Sähköposti",
    password: "Salasana",
    signUp: "Rekisteröidy",
    loginSuccess: "Kirjautuminen onnistui",
    accountCreated: "Tili luotu"
  },
  userPage: {
    title: "Käyttäjäprofiili",
    tabs: {
      profile: "Profiili",
      orders: "Tilaukset",
      storages: "Varastot",
      settings: "Asetukset"
    }
  },
  search: {
        selectImage: "Valitse kuva",
    compressingImages: "Pakataan kuvia...",
    cropping: "Rajataan...",
    imageCompressionError: "Kuvien käsittely epäonnistui. Yritä uudelleen.",
    captureError: "Kuvan ottaminen epäonnistui. Yritä uudelleen.",
    cropError: "Kuvan rajaaminen epäonnistui. Yritä uudelleen.",
    products: "Tuotteet",
    uploadImages: "Odota hetki...",
    uploadingImages: "Ladataan kuvia...",
    suggestions: "Suositukset",
    journey: {
      from: "Mistä",
      fromPlaceholder: "Kaupunki tai asema",
      to: "Minne",
      toPlaceholder: "Kaupunki tai asema",
      date: "Päivämäärä",
      selectDate: "Valitse päivä",
      passengers: "Matkustajat",
      search: "Hae"
    },
    logistics: {
      pickup: "Nouto",
      pickupPlaceholder: "Noutopaikka",
      dropoff: "Toimitus",
      dropoffPlaceholder: "Toimituspaikka",
      pickupDate: "Noutopäivä"
    },
    locationRecommended: "Sijainti",
    deliveryOptionsBuy: "Milloin tarvitset?",
    deliveryOptionsSell: "Mitä haluaisit myydä?",
    buy: "Osta",
    sell: "Myy",
    services: "Palvelut",
    placeholderBuyService: "Mitä palvelua tarvitset?",
    placeholderSellService: "Mitä palvelua tarjoat?",
    addImages: "Lisää kuvia",
    cropImage: "Rajaa kuva",
    selectedImages: "Valitut kuvat",
    useImages: "Käytä kuvia",
    maxImagesReached: "Kuvien enimmäismäärä saavutettu",
    placeholder: "Etsi mitä tahansa...",
    placeholderRent: "Kirjoita mitä myyt tai ota kuva",
    resultsFor: "Hakutulokset hakusanalle",
    productsFound: "tuotetta löytyi",
    noResults: "Tuotteita ei löytynyt",
    tryDifferent: "Kokeile eri hakusanoja",
    locationWarning: "Aseta sijaintisi saadaksesi parempia tuloksia",
    search: "Haku",
    analyzing: "Analysoidaan...",
    imageSearchFailed: "Kuvahaku epäonnistui. Yritä uudelleen.",
    cameraComingSoon: "Kuvahaku tulossa pian!",
    dragDropImages: "Vedä ja pudota kuvat tähän",
    orSelectFiles: "tai klikkaa valitaksesi tiedostot",
    takePhoto: "Ota kuva",
    uploadFromDevice: "Lataa laitteelta",
    maxImagesInfo: "Maksimi 5 kuvaa • PNG, JPG, WEBP",
    cameraError: "Kameraan ei saatu yhteyttä. Tarkista käyttöoikeudet.",
    cropSize: "Rajauksen koko",
    zoom: "Zoomaus",
    applyCrop: "Käytä rajausta",
    placeholderBuy: "Mitä tarvitset?",
    placeholderBuyMobile: "Mitä tarvitset?",
    placeholderSell: "Mitä tarjoat tai lisää kuva",
    placeholderSellMobile: "Mitä tarjoat?",
    imageSearch: "Hae kuvalla",
    suggestedCategory: "Ehdotettu kategoria:",
    otherCategories: "Muut kategoriat:",
    recentSearches: "Viimeisimmät haut",
    suggestedCategory: "Ehdotettu kategoria:",
    suggestedCategoryHint: "Napauta hakeaksesi useammasta kaupasta",
    allProductsLoaded: "Kaikki tuotteet ladattu",
    suggestedCategoryPrompt: "Napauta hakeaksesi lisää tuotteita tästä kategoriasta",
    emptyStateBuy: "Kirjoita nähdäksesi vaihtoehtoja",
    emptyStateSell: "Kirjoita nähdäksesi ehdotuksia"
  },
  type: {
    product: "Tuote",
    service: "Palvelu",
    products: "Tuotteet",
    services: "Palvelut"
  },
  service: {
    description: "Kuvaus",
    details: "Palvelun tiedot",
    location: "Sijainti",
    availability: "Saatavuus",
    website: "Verkkosivu",
    phone: "Puhelin",
    priceOnRequest: "Hinta pyydettäessä",
    hour: "tunti",
    day: "päivä",
    from: "Alkaen",
    book: "Varaa",
    contact: "Ota yhteyttä",
    provider: "Palveluntarjoaja",
    openToday: "Avoinna",
    closedToday: "Suljettu"
  },
  services: {
    journeyTickets: "Matkat",
    "journey-tickets": "Matkat",
    journeyTicketsDesc: "Varaa taksit, junat, bussit, lennot ja kimppakyydit",
    noResults: "Palveluita ei löytynyt",
    tryDifferent: "Kokeile eri hakusanoja",
    allServicesLoaded: "Kaikki palvelut ladattu",
    locationHelpsResults: "Sijainnin lisääminen auttaa näyttämään lähellä olevat palvelut.",
    health: "Terveys & Hyvinvointi",
    healthDesc: "Lääkäri, terapia, valmennus",
    logistics: "Logistiikka & Kuljetus",
    logisticsDesc: "Muutto, lähetys, kuriiripalvelut",
    entertainment: "Viihde",
    entertainmentDesc: "Tapahtumat, musiikki, esiintyjät",
    homeServices: "Kotipalvelut",
    homeServicesDesc: "Siivous, korjaukset, huolto",
    education: "Koulutus & Opetus",
    educationDesc: "Tunnit, kurssit, tukiopetus",
    beauty: "Kauneus & Muotoilu",
    beautyDesc: "Hiukset, meikki, spa-palvelut",
    photography: "Valokuvaus & Video",
    photographyDesc: "Tapahtumat, muotokuvat, mainonta",
    petServices: "Lemmikkipalvelut",
    petServicesDesc: "Ulkoilutus, trimmaus, hoito",
    childcare: "Lastenhoito",
    childcareDesc: "Lastenhoito, lastenhoitaja",
    repairs: "Korjaukset & Tekniikka",
    repairsDesc: "Laitekorjaus, IT-tuki",
    other: "Muut palvelut"
  },
  serviceRequest: {
    drawerTitle: "Pyydä palvelua",
    cardTitle: "Tarvitsetko palvelua?",
    cardDescription: "Pyydä mitä tahansa palvelua ja me etsimme sen",
    requestButton: "Pyydä",
    promise: "Autamme sinua löytämään oikean palveluntarjoajan",
    imageHint: "Kerro mitä palvelua tarvitset",
    cantFind: "Etkö löydä tarvitsemaasi palvelua?",
    helpText: "Kerro meille ja autamme sinua löytämään sen.",
    name: "Palvelun nimi",
    namePlaceholder: "esim. Kodin siivous",
    description: "Kuvaus (valinnainen)",
    descriptionPlaceholder: "Mihin tarvitset apua?",
    whereToFind: "Mistä tämän palvelun löytää?",
    website: "Verkkosivu",
    location: "Sijainti / Alue",
    locationPlaceholder: "esim. Helsingin alue",
    submit: "Lähetä",
    sourceRequired: "Anna verkkosivu tai sijainti",
    successMessage: "Pyyntö lähetetty! Autamme sinua löytämään oikean tarjoajan.",
    errors: {
      nameRequired: "Palvelun nimi vaaditaan",
      invalidUrl: "Anna kelvollinen URL-osoite"
    }
  },
  category: {
    details: "Kategoria",
    subcategories: "Alakategoriat",
    browseAll: "Selaa kaikkia"
  },
  categories: {
    tickets: 'Matkaliput',
    fuel: "Polttoaine",
    any: "Mikä tahansa",
    "home-garden": "Koti ja puutarha",
    all: "Kaikki kategoriat",
    "surplus-restaurant": "Ylijäämä ravintolasta",
    "outlet-electronics": "Outlet elektroniikka",
    "surplus-groceries": "Ylijäämä ruokakauppa",
    "surplus-flower": "Ylijäämäkukat",
    flower: "Kukat",
    groceries: "Ruokakauppa",
    restaurant: "Ravintolat",
    food: "Ruoka ja ravintolat",
    electronics: "Elektroniikka",
    clothing: "Vaatteet ja muoti",
    homeGarden: "Koti ja puutarha",
    beauty: "Kauneus ja hygienia",
    sports: "Urheilu ja ulkoilu",
    books: "Kirjat",
    toys: "Lelut ja pelit",
    health: "Terveys ja hyvinvointi",
    automotive: "Autotarvikkeet",
    pets: "Lemmikkitarvikkeet",
    office: "Toimistotarvikkeet",
    other: "Muut",
    product: {
      location: "Sijainti",
      askSeller: 'Kysy myyjältä',
      makeOffer: 'Tee tarjous',
      flowers: "Kukat",
      food: "Ruoka",
      electronics: "Elektroniikka",
      furniture: "Huonekalut",
      vehicles: "Ajoneuvot",
      other: "Muut"
    }
  },
  subcategories: {
    journey: {
      taxi: "Taksi",
      train: "Juna",
      bus: "Bussi",
      flight: "Lento",
      carpool: "Kimppakyyti"
    },
    health: {
      generalDoctor: "Yleislääkäri",
      pharmacy: "Apteekki",
      vaccination: "Rokotus",
      mentalHealth: "Mielenterveys",
      physiotherapy: "Fysioterapia"
    },
    logistics: {
      packageDelivery: "Pakettien toimitus",
      storage: "Varastointi",
      moving: "Muuttopalvelut",
      freight: "Rahti"
    },
    entertainment: {
      liveMusic: "Live-musiikki",
      movies: "Elokuvat",
      events: "Tapahtumat",
      dj: "DJ-palvelut"
    },
    home: {
      painting: "Maalaus",
      electrical: "Sähkötyöt",
      plumbing: "Putkityöt",
      gardening: "Puutarhanhoito",
      cleaning: "Siivous",
      furniture: "Huonekalujen kokoaminen"
    },
    education: {
      language: "Kielikurssit",
      tutoring: "Tukiopetus",
      artClasses: "Taidekurssit",
      coding: "Ohjelmointikurssit"
    },
    beauty: {
      hair: "Kampaamopalvelut",
      nails: "Kynsipalvelut",
      makeup: "Meikkaus",
      spa: "Kylpylä ja hieronta"
    },
    photography: {
      event: "Tapahtumavalokuvaus",
      video: "Videokuvaus",
      portrait: "Muotokuvaus",
      commercial: "Mainosvalokuvaus"
    },
    pet: {
      grooming: "Lemmikkien trimmaus",
      walking: "Koiran ulkoilutus",
      vet: "Eläinlääkäri",
      training: "Lemmikkien koulutus"
    },
    childcare: {
      babysitting: "Lastenhoito",
      daycare: "Päivähoito",
      tutoring: "Lasten tukiopetus"
    },
    repairs: {
      appliance: "Kodinkoneiden korjaus",
      electronics: "Elektroniikan korjaus",
      car: "Autokorjaus"
    },
    all: "Kaikki",
    popular: "Suositut",
    new: "Uutuudet",
    deals: "Parhaat tarjoukset",
    // Fuel
    fuel: {
      95: "95",
      98: "98",
      diesel: "Diesel"
    },
    // Electronics
    electronics: {
      outlet: "Outlet-elektroniikka",
      phones: "Puhelimet & Tabletit",
      computers: "Tietokoneet & Kannettavat",
      accessories: "Lisävarusteet"
    },
    // Restaurant
    restaurant: {
      surplus: "Ylijäämäruoka",
      fastFood: "Pikaruoka",
      fineDining: "Fine Dining",
      cafe: "Kahvila & Kahvi"
    },
    // Groceries
    groceries: {
      surplus: "Ylijäämäruoka",
      fresh: "Tuoretuotteet",
      frozen: "Pakasteet",
      beverages: "Juomat"
    }
  },
  productRequest: {
    drawerTitle: "Pyydä tuotetta",
    cardTitle: "Etkö löydä etsimääsi?",
    cardDescription: "Pyydä mitä tahansa tuotetta ja me etsimme sen",
    requestButton: "Pyydä",
    imageHint: "Kerro mitä etsit",
    name: "Tuotteen nimi",
    namePlaceholder: "esim. iPhone 15 Pro Max",
    descriptionPlaceholder: "Väri, koko, malli...",
    whereToFind: "Mistä sen löytää?",
    website: "Verkkosivu",
    location: "Kauppa / Sijainti",
    locationPlaceholder: "esim. Stockmann Helsinki",
    sourceRequired: "Anna verkkosivu tai sijainti",
    buttonText: "Pyydä tuotetta",
    title: "Pyydä tuote",
    promise: "Lupaamme lisätä pyytämäsi tuotteen 24 tunnin kuluessa!",
    description: "Kuvaile meille, mitä etsit",
    cantFind: "Etkö löydä etsimääsi?",
    helpText: "Kerro meille ja lisäämme sen markkinapaikkaamme 24 tunnin kuluessa.",
    productName: "Tuotteen nimi",
    productNamePlaceholder: "esim. Nike Air Max 90",
    productUrl: "Tuotteen URL",
    urlHelper: "Linkki tuotteeseen toisella verkkosivustolla",
    additionalInfo: "Lisätiedot",
    additionalInfoPlaceholder: "Tarkemmat tiedot, koko, väri jne.",
    cancel: "Peruuta",
    submit: "Lähetä pyyntö",
    successMessage: "Kiitos! Lisäämme tämän tuotteen 24 tunnin kuluessa.",
    errors: {
      nameRequired: "Tuotteen nimi vaaditaan",
      urlRequired: "Tuotteen URL vaaditaan",
      invalidUrl: "Anna kelvollinen URL"
    }
  },
  address: {
    editAddress: "Muokkaa osoitetta",
    mainAddress: "Osoite",
    streetAddress: "Katuosoite",
    postalCode: "Postinumero",
    city: "Kaupunki",
    country: "Maa",
    addressDetails: "Osoitetiedot",
    detailsHelp: "Tarkat osoitetiedot auttavat meitä toimittamaan tilauksesi nopeammin.",
    locationType: "Sijaintityyppi",
    house: "Talo",
    apartment: "Kerrostalo",
    office: "Toimisto",
    other: "Muu",
    entrance: "Sisäänkäynti / Porras",
    floor: "Kerros",
    howToGetIn: "Miten pääsemme sisään?",
    doorbell: "Ovikello / Portinpuhelin",
    doorCode: "Ovikoodi",
    doorOpen: "Ovi on auki",
    accessOther: "Muu (kerro meille miten)",
    enterDoorCode: "Ovikoodi",
    additionalInstructions: "Muut ohjeet lähettille",
    instructionsPlaceholder: "esim. Soita ovikelloa kahdesti",
    optional: "Valinnainen",
    addressLabel: "Osoitetunniste",
    labelHelp: "Osoitteiden merkitseminen auttaa sinua valitsemaan niiden välillä. Valitse 'Muu' luodaksesi oman tunnisteen.",
    home: "Koti",
    work: "Työ",
    customLabel: "Oma tunniste",
    customLabelPlaceholder: "esim. Äidin luona",
    coordinates: "Sijaintikoordinaatit",
    cancel: "Peruuta",
    save: "Tallenna osoite"
  },
  filters: {
    marketplace: 'Markkina',
    sourceCount: "{{enabled}}/{{total}}",
    sourceOptions: {
      all: "Kaikkialta",
      secondHand: "Käytetyt",
      new: "Uudet",
      library: "Kirjasto",
      cheap: "Edulliset"
    },
    selectSource: 'Valitse lähde',
    sourceType: 'Lähteen tyyppi',
    searchSites: 'Hakusivustot',
    selectSitesHelper: 'Lisää sivustoja lisätään tulevaisuudessa – kerro meille, mitä tarvitset.',
    apply: "Käytä",
    allServices: "Kaikki palvelut",
    categories: "Kategoriat",
    availability: "Saatavuus",
    priceType: "Hintatyyppi",
    allCategories: "Kaikki kategoriat",
    location: "Sijainti",
    locationAny: "Missä tahansa",
    category: "Kategoria",
    categoryAny: "Kaikki kategoriat",
    delivery: "Toimitus",
    deliveryAny: "Kaikki toimitustavat",
    subcategory: "Alikategoria",
    quality: "Kunto",
    type: "Tyyppi",
    all: "Kaikki",
    clear: "Tyhjennä",
    selectCategory: "Valitse kategoria",
    condition: "Kunto",
    source: "Lähde",
    allFilters: "Kaikki suodattimet",
    sort: "Järjestä",
    any: "Mikä tahansa",
    priceLowToHigh: "Hinta: edullisin ensin",
    priceHighToLow: "Hinta: kallein ensin",
    price: "Hinta",
    reset: "Nollaa suodattimet"
  },
  categorySelector: {
    title: "Valitse kategoria",
    allCategories: "Kaikki kategoriat",
    food: "Ruoka",
    electronics: "Elektroniikka",
    flowers: "Kukat",
    cancel: "Peruuta",
    apply: "Käytä suodatinta"
  },
  qualitySelector: {
    title: "Valitse laatu",
    allQuality: "Kaikki laadut",
    new: "Uusi",
    used: "Käytetty",
    cancel: "Peruuta",
    apply: "Käytä suodatinta"
  },
  typeSelector: {
    title: "Valitse tyyppi",
    allTypes: "Kaikki tyypit",
    onSale: "Myynnissä",
    buying: "Ostossa",
    lending: "Lainassa",
    cancel: "Peruuta",
    apply: "Käytä suodatinta"
  },
  location: {
    notSet: "Sijainti ei asetettu",
    generalLocation: "Suomesta",
    noOptions: "Ei vaihtoehtoja",
    resultsForLocation: "Tulokset alueelle",
    deliverTo: "Toimitus paikkaan",
    setLocation: "Aseta sijainti",
    description: "Syötä sijainti tai käytä automaattista tunnistusta",
    enterLocation: "Syötä sijainti",
    placeholder: "esim. Helsinki",
    cancel: "Peruuta",
    save: "Tallenna",
    detectHint: "Napsauta kuvaketta lisätäksesi sijainti automaattisesti",
    notSupported: "Selaimesi ei tue paikannusta",
    permissionDenied: "Sijaintilupa evättiin. Ota sijaintioikeudet käyttöön.",
    unavailable: "Sijaintitiedot eivät ole saatavilla.",
    timeout: "Sijaintipyynnön aikakatkaisu.",
    error: "Sijaintia ei voitu hakea",
    fetchError: "Sijainnin nimeä ei voitu hakea"
  },
  home: {
    quickAccessArea: "Löydä parhaat tarjoukset alueella {{area}}",
    search: {
      uploadImages: 'Odota hetki...',
      buyProduct: "Mitä tarvitset?",
      sellProduct: "Mitä myyt?",
      buyService: "Kuvaile tarvitsemasi palvelu...",
      sellService: "Kuvaile palvelusi..."
    },
    tips: {
      buyService: "Esimerkki: Junaliput Helsingistä Turkuun",
      sellService: "Esimerkki: Nurmikon leikkuu Helsingin alueella"
    },
    browseCategories: "Selaa kaikkia kategorioita →",
    generalLocation: "Aseta sijainti",
    browse: "Selaa",
    trendingNow: "Suosittua tällä hetkellä",
    popularCategories: "Suositut kategoriat",
    topServices: "Suosituimmat palvelut",
    moreServicesComing: "Lisää palvelukategorioita tulossa pian!",
    footer: {
      help: "Ohjeet",
      privacy: "Tietosuoja",
      terms: "Ehdot"
    },
    logo: "Marget",
    tagline: "Kaikki mitä tarvitset, yhdessä paikassa",
    hero: {
      title: "Tervetuloa OmaMarkkinaan",
      subtitle: "Oma markkinapaikkasi kaikelle",
      cta: "Aloita ostokset"
    },
    features: {
      title: "Miksi valita meidät",
      selection: {
        title: "Laaja valikoima",
        description: "Selaa laajaa teknologiatuotevalikoimaamme"
      },
      delivery: {
        title: "Nopea toimitus",
        description: "Saat tilauksesi 2-3 arkipäivässä"
      },
      payment: {
        title: "Turvallinen maksu",
        description: "Osta luottavaisesti turvallisen maksujärjestelmän avulla"
      }
    },
    stats: {
      users: "{{count}} aktiivista käyttäjää",
      listings: "{{count}} ilmoitusta",
      categories: "{{count}} kategoriaa"
    }
  },
  products: {
    "searchPlaceholder": "Hae tuotteita...",
    "emptyState": {
      "title": "Aloita kirjoittamalla haku",
      "description": "Hae tuotteita, selaa kategorioita tai tutustu eri lähteisiin löytääksesi etsimäsi."
    },
    "noResults": {
      "title": "Tuotteita ei löytynyt"
    },
    title: "Tuotteemme",
    addToCart: "Lisää ostoskoriin",
    viewDetails: "Näytä tiedot",
    backToProducts: "Takaisin tuotteisiin",
    notFound: "Tuotetta ei löytynyt",
    categories: {
      Audio: "Audio",
      Wearables: "Puettavat",
      Accessories: "Lisävarusteet",
      Peripherals: "Oheislaitteet"
    }
  },
  cart: {
    title: "Ostoskori",
    empty: "Ostoskorisi on tyhjä",
    total: "Yhteensä",
    checkout: "Kassalle",
    each: "kpl",
    quantity: "Määrä"
  },
  checkout: {
    pickupCode: "Noutotunnus",
    pickupConfirmationDesc: "Kooste noutotapahtumasta",
    pickUpConfirmation: "Nouto vahvistettu",
    pickupDetails: "Noutotiedot",
    whenPickingUp: "Noutoaika",
    pickupLocation: "Noutopaikka",
    confirmPickup: "Vahvista nouto",
    addToCalendar: "Lisää kalenteriin",
    pickupTime: "Noutoaika",
    deliveryLocation: "Noutopaikka",
    noPickupOptions: "Ei noutovaihtoehtoja saatavilla",
    loadingDeliveryOptions: "Ladataan toimitusvaihtoehtoja...",
    medicalAdvice: {
      title: "Lääkeneuvonta",
      question: "Haluatko lääkeneuvontaa?"
    },
    proceedToPayment: "Siirry maksamaan",
    paymentError: "Maksun luominen epäonnistui. Yritä uudelleen.",
    emailRequired: "Sähköposti vaaditaan",
    title: "Kassa",
    orderSummary: "Tilauksen yhteenveto",
    subtotal: "Välisumma",
    delivery: "Toimitus",
    pickup: "Nouto",
    continueShopping: "Jatka ostoksia",
    emptyCart: "Ostoskorisi on tyhjä",
    deliveryMethod: "Toimitustapa",
    paymentMethod: "Maksutapa",
    moreOptions: "lisää toimitusvaihtoehtoja",
    morePaymentMethods: "lisää maksutapoja",
    showLess: "Näytä vähemmän",
    mobilepayHint: "Maksu vahvistetaan puhelinnumerollasi MobilePay-sovelluksessa",
    phoneNumber: "Matkapuhelinnumero",
    phonePlaceholder: "40 123 4567",
    phoneHelp: "Tarvitsemme puhelinnumerosi toimitusta varten",
    phoneRequired: "Puhelinnumero vaaditaan MobilePay-maksuun",
    confirmOrder: "Vahvista tilaus",
    setAddress: "Aseta toimitusosoite",
    addressSaveError: "Osoitteen tallennus epäonnistui",
    loginRequired: "Ole hyvä ja kirjaudu sisään jatkaaksesi",
    selectCustomTime: "Valitse toimituspäivä ja -aika",
    error: "Tapahtui virhe. Yritä uudelleen.",
    selectDeliveryTime: "Valitse toimitusaika",
    selectDateFirst: "Valitse ensin päivä, sitten aikaväli",
    deliveryDate: "Toimituspäivä",
    timeSlot: "Aikaväli",
    storage: "Storage",
    multipleStorages: "Multiple storages",
    locations: "locations",
    editing: "Editing",
    viewAllLocations: "View all locations",
    deliveryOptions: "Delivery Options",
    deliveryAddress: "Delivery Address",
    selectDeliveryOption: "Click to select delivery option",
    openingHours: "Opening hours",
    // May already exist
    estimatedDelivery: "Estimated delivery",
    // May already exist
    noDeliveryOptions: "No delivery options available" // May already exist
  },
  product: {
    askSeller: 'Kysy myyjältä',
    makeOffer: 'Tee tarjous',
    analyse: "Analysoi varasto",
    // Add these to the product object
    uploadPhotos: "Lisää kuvia",
    uploadPhotosHint: "Lisää kuvia saadaksesi enemmän kiinnostusta (valinnainen)",
    title: "Otsikko",
    titlePlaceholder: "esim. Valkoiset Nike Air Max",
    moreOptions: "Lisäasetukset",
    storage: "Varasto",
    status: {
      label: "Tila",
      available: "Saatavilla",
      reserved: "Varattu",
      sold: "Myyty",
      hidden: "Piilotettu",
      unavailable: "Ei saatavilla"
    },
    upload: "Lisää tuote",
    mainImage: "Pääkuva",
    viewPickupLocation: "Näytä noutopiste",
    deliveryTo: "Toimitus osoitteeseen",
    deliveryOptions: "Toimitusvaihtoehdot",
    soldBy: "Myyjä",
    location: "Sijainti",
    condition: "Kunto",
    posted: "Lisätty",
    type: "Tyyppi",
    seller: "Myyjä",
    memberSince: "Jäsenenä alkaen",
    addToCart: "Lisää koriin",
    fastDelivery: "Nopea toimitus",
    noImage: "Ei kuvaa saatavilla",
    buyNow: "Osta nyt",
    robotSeller: "Robottikauppias",
    createSellTitle: "Lisää tuote myyntiin",
    createRentTitle: "Lisää tuote vuokralle",
    createSuccess: "Tuote luotu onnistuneesti! Uudelleenohjataan...",
    createError: "Tuotteen luonti epäonnistui",
    name: "Tuotteen nimi",
    namePlaceholder: "esim. iPhone 13 Pro",
    nameRequired: "Tuotteen nimi on pakollinen",
    category: "Kategoria",
    categoryRequired: "Kategoria on pakollinen",
    price: "Hinta",
    pricePerDay: "Hinta per päivä",
    priceRequired: "Kelvollinen hinta vaaditaan",
    size: "Koko",
    descriptionPlaceholder: "Kuvaile tuotetta mahdollisimman tarkasti...",
    listForSale: "Listaa myyntiin",
    listForRent: "Listaa vuokralle",
    // Sections
    basicInfo: "Perustiedot",
    pricing: "Hinnoittelu",
    details: "Lisätiedot",
    description: "Kuvaus",
    productDetails: "Tuotteen tiedot"
  },
  size: {
    small: "Pieni",
    medium: "Keskikokoinen",
    large: "Iso",
    xl: "Erittäin iso"
  },
  condition: {
    new: "Uusi",
    likeNew: "Kuin uusi",
    good: "Hyvä",
    fair: "Tyydyttävä",
    poor: "Heikko"
  },
  storage: {
    selectedStorage: "Valittu varasto",
    change: "Vaihda",
    selectStorage: "Valitse varasto",
    storage: "Varasto",
    yourStorages: "Varastosi",
    create: "Luo varasto",
    update: "Päivitä varasto",
    basicInfo: "Perustiedot",
    name: "Varaston nimi",
    namePlaceholder: "esim. Päävarasto",
    postalCode: "Postinumero",
    address: "Osoite",
    addressPlaceholder: "Katuosoite",
    city: "Kaupunki",
    cityPlaceholder: "esim. Helsinki",
    deliveryOptions: "Toimitusvaihtoehdot",
    noDeliveryOptions: "Ei toimitusvaihtoehtoja",
    operatingDays: "Toimintapäivät",
    daysPerWeek: "{{count}} päivää viikossa",
    productsInStorage: "Tuotteet varastossa",
    noProducts: "Ei tuotteita tässä varastossa vielä",
    openingHours: "Aukioloajat",
    cutoff: "Raja-aika",
    itemCount: "{{count}} tuotetta",
    locationNotSet: "Sijaintia ei asetettu",
    noStorages: "Ei varastoja vielä",
    createFirst: "Luo ensimmäinen varastosi aloittaaksesi myymisen!",
    createSuccess: 'Varasto "{{name}}" luotu onnistuneesti!',
    createError: "Varaston luominen epäonnistui. Yritä uudelleen."
  },
  days: {
    monday: "Maanantai",
    tuesday: "Tiistai",
    wednesday: "Keskiviikko",
    thursday: "Torstai",
    friday: "Perjantai",
    saturday: "Lauantai",
    sunday: "Sunnuntai"
  },
  orderConfirmation: {
    title: "Tilaus vahvistettu!",
    message: "Kiitos ostoksestasi. Tilauksesi on tehty onnistuneesti.",
    continueShopping: "Jatka ostoksia"
  },
  productList: {
    wirelessHeadphones: {
      name: "Langattomat kuulokkeet",
      description: "Laadukkaat langattomat kuulokkeet melunvaimennuksella"
    },
    smartWatch: {
      name: "Älykello",
      description: "Monipuolinen älykello terveyden seurannalla"
    },
    laptopStand: {
      name: "Kannettavan teline",
      description: "Ergonominen alumiininen kannettavan teline"
    },
    mechanicalKeyboard: {
      name: "Mekaaninen näppäimistö",
      description: "RGB-mekaaninen näppäimistö sinisillä kytkin"
    },
    wirelessMouse: {
      name: "Langaton hiiri",
      description: "Ergonominen langaton hiiri tarkalla seurannalla"
    },
    usbcHub: {
      name: "USB-C-keskitin",
      description: "Moniporttinen USB-C-keskitin HDMI:llä ja kortinlukijoilla"
    }
  },
  common: {
        changeImage: "Vaihda kuva",
    deselectAll: "Poista valinnat",
    add: "Lisää",
    loading: "Ladataan...",
    error: "Virhe",
    success: "Onnistui",
    optional: "Valinnainen",
    clear: "Tyhjennä",
    copy: "Kopioi",
    copied: "Kopioitu",
    total: "Yhteensä",
    actions: "Toiminnot",
    reset: "Nollaa",
    done: "Valmis",
    cancel: "Peruuta",
    confirm: "Vahvista",
    save: "Tallenna",
    edit: "Muokkaa",
    delete: "Poista",
    close: "Sulje",
    back: "Takaisin",
    next: "Seuraava",
    gotIt: "Selvä!",
    apply: "Käytä",
    creating: "Luodaan...",
    showMore: "Näytä kaikki",
    showLess: "Näytä vähemmän",
    or: "tai"
  },
  // Add new photoTips object
  photoTips: {
    buttonText: "Valokuvavinkit",
    title: "Valokuvavinkkejä",
    quickTips: "Pikavinkit:",
    allDone: "Valmista!",
    readyMessage: "Nyt osaat ottaa hyviä kuvia. Aloita kuvaaminen!",
    reviewAgain: "Katso uudelleen",
    lighting: {
      title: "Hyvä valaistus",
      description: "Käytä luonnonvaloa kun mahdollista. Vältä kovia varjoja ja pimeitä nurkkia.",
      tips: ["Ota kuvia ikkunan lähellä", "Vältä suoraa auringonvaloa (liian kova)", "Kuvaa päivänvalossa", "Laita kaikki huoneen valot päälle sisällä"]
    },
    composition: {
      title: "Hyvä sommittelu",
      description: "Käytä ruudukkoa kohteen kohdistamiseen oikein.",
      tips: ["Sijoita tuote ruudukon risteyksiin", "Pidä horisontit suorina", "Jätä hieman tilaa tuotteen ympärille", "Keskitä tärkeät ominaisuudet"]
    },
    background: {
      title: "Siisti tausta",
      description: "Yksinkertainen, selkeä tausta saa tuotteesi erottumaan.",
      tips: ["Käytä tasaisia seiniä tai pintoja", "Poista tarpeettomat esineet", "Vältä vilkkaita kuvioita", "Pidä se yksinkertaisena ja siistinä"]
    },
    angles: {
      title: "Useita kulmia",
      description: "Näytä eri näkymiä lisätäksesi ostajien luottamusta.",
      tips: ["Etunäkymä (pääkuva)", "Sivu- ja takakuvat", "Lähikuvia yksityiskohdista", "Näytä mittakaava (tavallisella esineellä)"]
    },
    quality: {
      title: "Kuvan laatu",
      description: "Laadukkaat kuvat rakentavat luottamusta ostajiin.",
      tips: ["Pidä kamera vakaana", "Puhdista linssi", "Käytä korkeaa resoluutiota", "Vältä zoomausta (mene lähemmäs sen sijaan)"]
    }
  },
  myProfile: "Profiili ja asetukset",
  myOrders: "Tilaukseni",
  logout: "Kirjaudu ulos",
  orders: {
    title: "Tilaushistoria",
    noOrders: "Ei tilauksia vielä",
    noOrdersDescription: "Tilaushistoriasi näkyy täällä",
    startShopping: "Aloita Ostokset",
    orderCount: "Sinulla on {{count}} tilaus",
    orderCount_plural: "Sinulla on {{count}} tilausta",
    selected: "{{count}} valittu",
    printSelected: "Tulosta Valitut",
    selectAtLeastOne: "Valitse vähintään yksi tilaus tulostettavaksi.",
    printWaybillError: "Rahtikirjan tulostus epäonnistui. Yritä uudelleen.",
    printReceiptError: "Kuitin tulostus epäonnistui. Yritä uudelleen.",
    printDocumentsError: "Asiakirjojen tulostus epäonnistui. Yritä uudelleen.",
    table: {
      orderId: "Tilausnumero",
      date: "Päivämäärä",
      products: "Tuotteet",
      price: "Hinta",
      status: "Tila",
      actions: "Toiminnot",
      items: "Tuotteet",
      itemCount: "{{count}} tuote",
      itemCount_plural: "{{count}} tuotetta"
    },
    status: {
      pending: "Odottaa",
      processing: "Käsittelyssä",
      shipped: "Lähetetty",
      delivered: "Toimitettu",
      cancelled: "Peruttu",
      confirmed: "Vahvistettu"
    },
    details: {
      items: "Tuotteet",
      contactInfo: "Yhteystiedot",
      phone: "Puhelin",
      destination: "Kohde"
    }
  },
  settings: {
    title: "Asetukset",
    appearance: "Ulkoasu",
    lightMode: "Vaalea",
    darkMode: "Tumma",
    systemDefault: "Järjestelmän oletus",
    darkModeToggle: "Tumma tila",
    darkModeDescription: "Nopea vaihto tumalle teemalle",
    currentTheme: "Nykyinen teema",
    followingSystem: "seuraa järjestelmää",
    preferences: "Asetukset",
    saveSuccess: "Asetukset tallennettu onnistuneesti!",
    saveError: "Asetuksien tallentaminen epäonnistui. Yritä uudelleen.",
    saveButton: "Tallenna asetukset",
    userMode: {
      title: "Käyttäjän rooli",
      description: "Valitse pääasiallinen rooli alustan käytössä",
      label: "Rooli",
      buyer: "Ostaja - Selaa ja osta tuotteita",
      seller: "Myyjä - Listaa ja myy tuotteita",
      lender: "Vuokraaja - Vuokraa omat tuotteesi"
    },
    language: {
      title: "Kieli ja alue",
      label: "Kieli",
      finnish: "Suomi (Finnish)",
      english: "English",
      swedish: "Svenska (Swedish)"
    },
    notifications: {
      title: "Ilmoitukset",
      description: "Hallinnoi kuinka vastaanotat ilmoituksia",
      push: "Push-ilmoitukset",
      pushDescription: "Saa ilmoituksia tilauksia ja viestejä koskien",
      email: "Sähköposti-päivitykset",
      emailDescription: "Vastaanota markkinointi-sähköposteja ja päivityksiä"
    },
    privacy: {
      title: "Yksityisyys",
      description: "Hallinnoi yksityisyysasetuksia ja tietojen käyttöä",
      manageButton: "Hallinnoi yksityisyysasetuksia"
    }
  },
  profile: {
    updateSuccess: "Profiili päivitetty onnistuneesti!",
    updateError: "Profiilin päivittäminen epäonnistui. Yritä uudelleen.",
    editButton: "Muokkaa Profiilia",
    cancelButton: "Peruuta",
    saveButton: "Tallenna Muutokset",
    validation: {
      firstNameRequired: "Etunimi vaaditaan",
      lastNameRequired: "Sukunimi vaaditaan",
      emailRequired: "Sähköposti vaaditaan",
      invalidEmail: "Anna kelvollinen sähköpostiosoite",
      invalidPhone: "Anna kelvollinen puhelinnumero"
    },
    fields: {
      firstName: "Etunimi",
      lastName: "Sukunimi",
      email: "Sähköposti",
      phone: "Puhelinnumero",
      phonePlaceholder: "+358 40 123 4567",
      optional: "Valinnainen"
    },
    accountInfo: {
      title: "Tilin Tiedot",
      userId: "Käyttäjätunnus",
      postalCode: "Postinumero",
      notSet: "Ei asetettu",
      roles: "Roolit"
    }
  },
  orderStatus: {
    loading: "Ladataan tilauksen tilaa...",
    error: "Jotain meni pieleen",
    success: "Tilaus vahvistettu!",
    successMessage: "Kiitos tilauksestasi. Tilauksesi on vastaanotettu.",
    cancelled: "Maksu peruutettu",
    cancelledMessage: "Maksusi peruutettiin. Veloitusta ei tehty.",
    pending: "Käsittelemme tilaustasi",
    pendingMessage: "Tilauksesi on vastaanotettu ja vahvistamme sen hetken kuluttua.",
    orderNumber: "Tilausnumero",
    total: "Yhteensä",
    items: "tuotetta",
    item: "tuote",
    robotHandling: "Robotti hoitaa tilaustasi",
    confirmationEmail: "Saat vahvistuksen sähköpostiin pian",
    viewOrders: "Näytä tilaukseni"
  },
  payment: {
    success: "Maksu onnistui!",
    successMessage: "Kiitos tilauksestasi. Saat vahvistuksen sähköpostiisi pian.",
    cancelled: "Maksu peruutettu",
    cancelledMessage: "Maksusi peruutettiin. Veloitusta ei tehty.",
    orderNumber: "Tilausnumero",
    tryAgain: "Yritä uudelleen",
    continueShopping: "Jatka ostoksia"
  },
  theme: {
    darkMode: "Tumma tila",
    lightMode: "Vaalea tila",
    toggle: "Vaihda teemaa"
  },
  language: {
    title: "Kieli",
    select: "Valitse kieli",
    en: "Englanti",
    fi: "Suomi",
    sv: "Ruotsi"
  },
  inbox: {
    title: "Viestit",
    noConversations: "Ei keskusteluja vielä",
    noMessages: "Ei viestejä vielä",
    noConversationsInTab: "Ei keskusteluja tässä kategoriassa",
    noInquiriesForProduct: "Ei kyselyitä tälle tuotteelle vielä",
    messagePlaceholder: "Kirjoita viesti...",
    startConversation: "Aloita keskustelu lähettämällä viesti",
    inquiriesFor: "Kyselyt tuotteelle {{product}}",
    tabs: {
      all: "Kaikki",
      purchases: "Ostokset",
      inquiries: "Kyselyt"
    },
    type: {
      purchase: "Ostos",
      inquiry: "Kysely"
    }
  },
  // ============================================
  // LAKI / LEGAL
  // ============================================
  legal: {
    howItWorks: {
      title: "Miten Marget toimii",
      intro: "Marget on älykäs kaupankäynnin ekosysteemi, joka auttaa käyttäjiä löytämään tuotteita ja palveluita, vertailemaan vaihtoehtoja ja tekemään kauppoja joustavilla toimitusvaihtoehdoilla.",
      roles: {
        title: "Käyttäjäroolit",
        body: "Yhdellä Marget-tilillä voi olla useita rooleja. Riippuen siitä, miten käytät palvelua, soveltuvat eri säännöt ja vastuut.",
        buyer: "Ostaja",
        seller: "Myyjä",
        logistics: "Kuriiri / logistiikkaoperaattori"
      },
      marketplace: {
        title: "Markkinapaikka (osta & myy)",
        body: "Marget kokoaa eri myyjien ja palveluntarjoajien ilmoituksia yhteen paikkaan. Voit selata, vertailla ja viestiä ennen kaupan tekemistä.",
        bullets: {
          search: "Etsi ja selaa tuotteita, palveluita ja second hand -ilmoituksia.",
          compare: "Vertaile hintaa, kuntoa/laatuarviota, sijaintia ja toimitusvaihtoehtoja.",
          contact: "Kysy lisätietoja ja saatavuutta viestien kautta.",
          checkout: "Tee kauppa ja seuraa tilauksen tai tehtävän tilaa sovelluksessa, kun saatavilla."
        }
      },
      delivery: {
        title: "Toimitus & logistiikka",
        body: "Toimituksen voi tarjota myyjä, kolmas osapuoli tai Margetissa toimivat kuriirit. Saatavuus riippuu usein sijainnista, ajankohdasta ja kapasiteetista.",
        bullets: {
          options: "Vaihtoehtoja voivat olla nouto, ajastettu toimitus tai nopea toimitus (jos saatavilla).",
          availability: "Kuriirien saatavuus ja hinnoittelu voivat vaihdella kysynnän ja etäisyyden mukaan.",
          tracking: "Aktiivisen kuljetustehtävän aikana voidaan käyttää rajattua seurantaa noudon ja toimituksen koordinointiin.",
          handover: "Käyttäjät vastaavat osoitteiden, kulkuohjeiden ja turvallisen luovutuksen oikeellisuudesta."
        }
      },
      payments: {
        title: "Maksut, hinnat ja palvelumaksut",
        body: "Hinnat asettaa myyjä tai palveluntarjoaja. Toimitusmaksut (jos soveltuu) riippuvat toimitustavasta ja saatavuudesta.",
        bullets: {
          pricing: "Ilmoituksissa näkyy myyjän tai palveluntarjoajan määrittämä hinta.",
          fees: "Marget voi periä alustan tai palvelun käytöstä maksuja riippuen tuotteesta tai palvelupolusta.",
          refunds: "Palautukset ja riidat riippuvat transaktiotyypistä ja sovellettavista ehdoista."
        }
      },
      safety: {
        title: "Luottamus, turvallisuus ja yhteisö",
        body: "Tavoitteemme on pitää Marget turvallisena kaikille. Käyttäjien tulee noudattaa ohjeita ja soveltuvaa lainsäädäntöä.",
        bullets: {
          guidelines: "Noudata yhteisöohjeita ja kiellettyjen tuotteiden sääntöjä.",
          reporting: "Ilmoita epäilyttävästä toiminnasta, huijauksista tai turvattomasta käytöksestä.",
          enforcement: "Rikkomukset voivat johtaa rajoituksiin, poistamiseen tai ilmoituksiin viranomaisille lain edellyttämällä tavalla."
        }
      },
      privacy: {
        title: "Data & yksityisyys",
        body: "Käsittelemme vain sellaista dataa, joka on tarpeen palvelun tuottamiseen, tukeen sekä turvallisuuden ja luotettavuuden parantamiseen.",
        bullets: {
          location: "Sijaintia voidaan käyttää logistiikan koordinointiin aktiivisen tehtävän aikana (ei jatkuvaa seurantaa tehtävän ulkopuolella).",
          minimization: "Pyrimme minimoimaan datan keruun ja rajaamaan säilytysajan.",
          controls: "Voit hallita tiettyjä yksityisyysasetuksia ja pyytää pääsyä tietoihin lain edellyttämällä tavalla."
        }
      },
      platformRole: {
        title: "Margetin rooli",
        body: "Marget tarjoaa teknisen alustan. Kaupat ja palvelut toteutuvat käyttäjien välillä (ostajat, myyjät ja logistiikkaoperaattorit). Emme ole jälleenmyyjä, kuriirien työnantaja tai kuljetusliike, ellei yksittäisessä palvelussa nimenomaisesti toisin kerrota."
      }
    }
  },
  cookieConsent: {
    title: "Evästeet ja yksityisyys",
    body: 'Käytämme evästeitä parantaaksemme käyttökokemustasi. Klikkaamalla "Hyväksy kaikki" hyväksyt evästeiden käytön. Voit hallita asetuksiasi tai lukea lisää siitä, miten käytämme evästeitä.',
    accept: "Hyväksy kaikki",
    reject: "Hylkää",
    manage: "Hallinnoi asetuksia",
    learnMore: "Lue lisää"
  },
  delivery: {
    route: "Reitti",
    origin: "Lähtöpaikka",
    destination: "Määränpää",
    originHelp: "Pakettisi noutopaikka",
    labelsInfo: "Tulosta lähhetystarrat ja kiinnitä ne paketteihin ennen noutoa.",
    selectProductsForLabels: "Valitse paketti, jolle haluat tulostaa tarrat",
    printLabelsSubtitle: "Valitse paketti ja tulosta osoitetarrat",
    printLabels: "Print Labels",
    pickupNow: "Nyt",
    pickupDate: "Noutopäivä",
    pickupTimeModal: {
      title: "Noutoaika",
      time: "Noutoaika"
    },
    today: "tänään",
    tomorrow: "huomenna",
    standard: "1-5 päivää",
    any: "ei aikatoivetta toimitukselle",
    from: "Lähtöpaikka",
    to: "Määränpää",
    bustransport: "Bussikuljetus",
    noDeliveries: "Ei kuljetuksia vielä",
    printWaybill: "Tulosta rahtikirja",
    resend: "Lähetä uudelleen",
    waybillPrinted: "Rahtikirja ladattu onnistuneesti",
    status: {
      active: "Aktiivinen",
      accepted: "Hyväksytty",
      picked: "Noudettu",
      completed: "Valmis",
      cancelled: "Peruutettu"
    },
    // Sivun otsikko
    sendPackage: "Lähetä paketti",
    // Paikka-kentät
    pickup: "Nouto",
    dropoff: "Toimitus",
    // Paketin koko
    selectPackageSize: "Valitse koko",
    size: "Koko",
    xl: "Erittäin suuri (90+ kg)",
    // Paino
    weight: "Paino (kg)",
    // Tiedot
    moreDetails: "Lisätietoja",
    detailsTitle: "📋 Lisätietoja",
    // Etäisyys ja kesto
    distance: "{{distance}} km",
    distanceWithDuration: "{{distance}} km • {{duration}} min",
    // Painikkeet ja toiminnot
    createDelivery: "Luo kuljetus",
    createDeliveryWithPrice: "Luo kuljetus • {{price}}€",
    create: "Luo",
    creating: "Luodaan...",
    creatingDelivery: "Luodaan...",
    // Arvio
    estimate: "Arvio",
    estimatedPrice: "Arvioitu hinta",
    // Toimitusvaihtoehdot
    deliveryOptions: "Toimitusvaihtoehdot",
    enterAddressesPrompt: "Syötä nouto- ja toimitusosoitteet nähdäksesi vaihtoehdot",
    // ✅ UUSI: Päätoimitustyypit
    express: "Pikatoimitus",
    expressDesc: "Nopein saatavilla oleva toimitus",
    fast: "Nopea",
    fastDesc: "Nopea toimituspalvelu",
    eco: "Eco",
    ecoDesc: "Edullisin vaihtoehto - joustava toimitus",
    // ✅ UUSI: Yleiset
    startingFrom: "Alkaen",
    earliestDelivery: "Aikaisin mahdollinen toimitus",
    // Vaihtoehtojen tyypit (olemassa olevat)
    busparcel: "Bussipaketti",
    busparcelDesc: "Bussipaketti - klikkaa valitaksesi",
    custom: "Mukautettu",
    customDesc: "Aseta oma hintasi",
    customPriceLabel: "Mukautettu hinta (€)",
    // ✅ UUSI: Eco-valikko
    selectEcoOption: "Valitse Eco-toimitusvaihtoehto",
    busTransport: "Bussikuljetus",
    busTransportDesc: "Toimitus julkisen liikenteen verkostossa",
    regular: "Normaali",
    regularDesc: "Tavallinen pakettitoimitus",
    bid: "Tarjous",
    bidDesc: "Aseta oma hintasi - ei taattu",
    // ✅ UUSI: Normaalitoimitus
    regularOptions: "Normaalitoimitus Vaihtoehdot",
    pickupLocation: "Nouto",
    deliveryLocation: "Toimitus",
    parcelCenter: "Pakettipiste",
    homePickup: "Nouto kotoa",
    homeDelivery: "Kotiinkuljetus",
    free: "Ilmainen",
    totalPrice: "Kokonaishinta",
    // ✅ UUSI: Tarjous
    bidTitle: "Aseta tarjouksesi",
    bidWarning: "Huomio: Tarjous ei takaa kuriirin löytymistä. Toimitusta ei välttämättä hyväksytä, jos hinta on liian alhainen.",
    yourPrice: "Hintasi",
    priceLabel: "Hinta (€)",
    pickupTime: "Noutoaika (Valinnainen)",
    targetTime: "Toimitusaika (Valinnainen)",
    date: "Päivämäärä",
    time: "Aika",
    // Erikoisvaihtoehdot
    specialOptions: "Erikoisvaihtoehdot",
    returnParcels: "Palautuspaketit",
    returnParcelsDesc: "Kuljettaja noutaa palautukset",
    temperatureControl: "Lämpötilan hallinta",
    temperatureControlDesc: "Vaatii lämpötilahallitun käsittelyn",
    canBeLeftAtDoor: "Voidaan jättää ovelle",
    canBeLeftAtDoorDesc: "Paketti voidaan jättää ilman allekirjoitusta",
    // Omat kuljetukset
    sendNew: "Lähetä uusi",
    myDeliveries: "Omat kuljetukset",
    resendNotification: "Kuljetuksen tiedot ladattu. Päivitä ja luo uusi kuljetus.",
    // Nouto- ja toimitusosiot
    pickupDetails: "Noutotiedot",
    deliveryDetails: "Toimitus tiedot",
    addressDetails: "Osoitetiedot",
    optional: "(Valinnainen)",
    senderInformation: "Lähettäjän tiedot",
    recipientInformation: "Vastaanottajan tiedot",
    notSelected: "Ei valittu",
    // Aika
    timeWindow: "Aika",
    target: "Tavoiteaika",
    timeWindowPriceNote: "Aikavälin määrittäminen lisää 4€ + ALV toimitushintaan",
    // ALV
    vat: "sis. ALV",
    // Lähettäjä/Vastaanottaja
    senderName: "Lähettäjän nimi",
    senderPhone: "Lähettäjän puhelinnumero",
    senderEmail: "Lähettäjän sähköpostiosoite",
    recipientName: "Vastaanottajan nimi",
    recipientPhone: "Vastaanottajan puhelinnumero",
    recipientEmail: "Vastaanottajan sähköpostiosoite",
    // Lomakekentät
    form: {
      apartmentNumber: "Asunnon numero",
      apartmentPlaceholder: "esim. 12B",
      floor: "Kerros",
      floorPlaceholder: "esim. 3. kerros",
      buildingName: "Rakennuksen nimi",
      buildingPlaceholder: "esim. Rakennus A",
      accessCode: "Pääsykoodi",
      accessCodePlaceholder: "esim. #1234*",
      pickupInstructions: "Nouto-ohjeet",
      pickupInstructionsPlaceholder: "Jätä paketti vastaanottoon, soita ovikelloa kahdesti, jne.",
      deliveryInstructions: "Toimitusohjeet",
      deliveryInstructionsPlaceholder: "Jätä ovelle, soita saapuessa, jne.",
      name: "Nimi",
      senderNamePlaceholder: "Lähettäjän nimi",
      recipientNamePlaceholder: "Vastaanottajan nimi",
      phone: "Puhelinnumero",
      phonePlaceholder: "+358 40 123 4567",
      email: "Sähköposti",
      emailPlaceholder: "esimerkki@email.com"
    },
    // Virheilmoitukset
    errors: {
      selectAddresses: "Valitse nouto- ja toimitusosoitteet.",
      selectOption: "Valitse toimitusvaihtoehto.",
      createFailed: "Kuljetuksen luonti epäonnistui."
    },
    // Onnistumisviestit
    success: {
      created: "Kuljetus luotu onnistuneesti!"
    },
    // Kokoluokat
    small: "Pieni",
    medium: "Keskikokoinen",
    large: "Suuri",
    extraLarge: "Erittäin suuri",
    // Tekniset tiedot
    specifications: "Tekniset tiedot",
    maxDimensions: "Maksimimitat",
    // Tuotteet
    items: "Tuotteet",
    item: "Tuote",
    addItem: "Lisää tuote",
    // Mitat
    length: "Pituus (cm)",
    width: "Leveys (cm)",
    height: "Korkeus (cm)",
    // Kokokuvaukset (PACKAGE_SIZES-konfiguraatioon)
    sizeDescriptions: {
      small: {
        example: "Helppo kantaa kädessä",
        description: "Kirjeet, asiakirjat, pienet paketit"
      },
      medium: {
        example: "Mahtuu auton tavaratilaan",
        description: "Keskikokoiset laatikot, urheiluvälineet"
      },
      large: {
        example: "Mahtuu pakettiautoon",
        description: "Suuret laatikot, huonekalut"
      },
      extraLarge: {
        example: "Mahtuu kuorma-autoon",
        description: "Kodinkoneet, suuret huonekalut"
      }
    },
    busTransportModal: {
      title: "Bussipaketti",
      departureTime: "Lähtöaika",
      deliveryOptions: "Toimitusvalinnat",
      includeFirstMile: "Nouto kotoa bussipysäkille",
      includeLastMile: "Toimitus bussipysäkiltä vastaanottajalle",
      // Varoitukset
      bothSelfService: "Sinun tulee viedä paketti lähtöasemalle ja vastaanottajan tulee noutaa se saapumisasemalta.",
      firstMileSelfService: "Sinun tulee viedä paketti lähtöasemalle itse.",
      lastMileSelfService: "Vastaanottajan tulee noutaa paketti saapumisasemalta.",
      // Vaiheiden otsikot
      selfService: "Itse",
      selfTransport: "Oma kuljetus",
      carTransport: "Kuljetus autolla",
      busTrip: "Bussimatka",
      // Yhteenveto
      distance: "Matka",
      duration: "Kesto",
      price: "Hinta",
      routeSteps: "Reitin vaiheet",
      priceBreakdown: "Hinnan erittely",
      departure: "Lähtö",
      arrival: "Saapuminen",
      // Toiminnot
      select: "Valitse bussipaketti",
      // Virheet
      fetchError: "Ei voitu hakea bussiyhteyksiä",
      generalError: "Virhe haettaessa bussivaihtoehtoja"
    }
  },
  processing: "Käsitellään...",
  // fi.json
  "storefront": {
    "joined": "Liittynyt",
    "userNotFound": "Käyttäjää ei löytynyt",
    "listings": "ilmoitusta",
    "searchProducts": "Hae tuotteita...",
    "noSearchResults": "Ei hakutuloksia",
    "noListings": "Ei ilmoituksia"
  },
  journeys: {
    origin: 'Lähtöpaikka',
    destination: 'Määräpaikka',
    today: 'Tänään',
    journeyGroups: 'matkaa',
    noTicketsFound: 'Lippuja ei löytynyt',
    searchNewTickets: 'Hae uusia',
    saveSearchAlert: 'Tallenna hakuvahti',
    searchForRoute: 'Hae uusia samalle reitille',
    searching: 'Etsitään...',
    ticketsFound: '{{count}} lippua löytynyt',
    selectDateTime: 'Päivämäärä & Aika',
    clear: 'Tyhjennä',
    cancel: 'Peruuta',
    apply: 'Käytä',
    columns: {
      date: 'Päivä',
      time: 'Aika',
      transportType: 'Kulkuväline',
      passengerType: 'Matkustaja',
      price: 'Hinta'
    },
    discover: {
      popularOrigins: 'Suositut lähtöpaikat',
      destinationsFrom: 'Mihin täältä?',
      routes: 'reittiä'
    },
    filters: {
      origin: 'Lähtöpaikka',
      destination: 'Määräpaikka',
      date: 'Päivä',
      time: 'Aika',
      transportType: 'Kulkuväline',
      passengerType: 'Matkustaja',
      ticketType: 'Lipputyyppi'
    },
    transportType: {
      train: 'Juna',
      bus: 'Bussi',
      plane: 'Lentokone',
      flight: 'Lentokone',
      carpool: 'Kimppakyyti',
      ferry: "Laiva",
      other: 'Muu'
    },
    passengerType: {
      adult: 'Aikuinen',
      student: 'Opiskelija',
      child: 'Lapsi',
      senior: 'Seniori',
      pensioner: 'Eläkeläinen'
    },
    errors: {
      required: 'Pakollinen kenttä',
      searchFailed: 'Haku epäonnistui. Yritä uudelleen.',
      requiredFields: 'Lähtöpaikka, määräpaikka ja päivä ovat pakollisia'
    }
  }
};
